import React, { useContext, useState } from 'react';
import LeftProfile from '../components/others/LeftProfile';
import myshops from "../assets/img/myshops.png";
import webluna from "../assets/img/webluna.png";
import webcoder from "../assets/img/webcoder.png";

import matrix from "../assets/img/matrix.png";
import adas from "../assets/img/adas.svg";
import wcu from "../assets/img/wcu.png";

import js from "../assets/img/js.png" ;
import html from "../assets/img/html.png" ;
import css from "../assets/img/css.png" ;
import react from "../assets/img/react.png" ;
import { Link, NavLink } from 'react-router-dom';
import portfolio from "../data/portfolio" ;
import { Helmet } from 'react-helmet';
import translations from '../data/langData';
import { LanguageContext } from '../context/LanguageContext';

const Home = () => {
  const [data,setData] = useState(portfolio)
  const { language } = useContext(LanguageContext);
  const t = translations[language];
  return (
    <>
       <Helmet>
      <title>{t.home}</title>
    </Helmet>
     <section className="home-area">
  <div className="container">
    <div className="row g-4">
      <LeftProfile/>
      <div className="col-xl-4">
        <div className="row g-4">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-body work-experiance-card">
                <h3 className="card-title">{t.workeducation}</h3>
                <div className="work-experiance-main">
                  <ul className="work-experiance-slider list-unstyled">
                    <li>
                      <div className="date">
                        <p>Currently</p>
                      </div>
                      <div className="info">
                        <div className="icon ms-2">
                          <img src={myshops} alt="My Shops" className='img-fluid' />
                        </div>
                        <div className="text">
                          <h4 className="title">My Shops</h4>
                          <h6 className="subtitle">Front-end Developer</h6>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="date">
                        <p>2023-2024</p>
                      </div>
                      <div className="info">
                        <div className="icon">
                          <img src={webluna} className='img-fluid' alt="Webluna Software" />
                        </div>
                        <div className="text">
                          <h4 className="title">Webluna Software
                          </h4>
                          <h6 className="subtitle">Front-end Developer
                          </h6>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="date">
                        <p>2023-2024</p>
                      </div>
                      <div className="info">
                        <div className="icon">
                          <img src={webcoder} alt="Webcoder Agency" />
                        </div>
                        <div className="text">
                          <h4 className="title">Webcoder Agency
                          </h4>
                          <h6 className="subtitle">Front-end Developer <br />(Intern)
                          </h6>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="date">
                        <p>2022-2023</p>
                      </div>
                      <div className="info">
                        <div className="icon">
                          <img src={matrix} alt="Matrix Academy" className='img-fluid' />
                        </div>
                        <div className="text">
                          <h4 className="title">Matrix Academy</h4>
                          <h6 className="subtitle">Front-end Developer</h6>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="date">
                        <p>2017-2021</p>
                      </div>
                      <div className="info">
                        <div className="icon ms-2">
                          <img src={wcu} alt="WCU" className='img-fluid' />
                        </div>
                        <div className="text">
                          <h4 className="title">WCU</h4>
                          <h6 className="subtitle">Polygraphy Engineer</h6>
                        </div>
                      </div>
                    </li>

                    <li>
                      <div className="date">
                        <p>2023-2024</p>
                      </div>
                      <div className="info">
                        <div className="icon">
                          <img src={adas} alt="Matrix Adas" className='img-fluid' />
                        </div>
                        <div className="text">
                          <h4 className="title">Adas</h4>
                          <h6 className="subtitle">Full-stack Developer</h6>
                        </div>
                      </div>
                    </li>
                  </ul>
                  <ul className="work-experiance-slider list-unstyled">
                  <li>
                      <div className="date">
                        <p>Currently</p>
                      </div>
                      <div className="info">
                        <div className="icon ms-2">
                          <img src={myshops} alt="My Shops" className='img-fluid' />
                        </div>
                        <div className="text">
                          <h4 className="title">My Shops</h4>
                          <h6 className="subtitle">Front-end Developer</h6>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="date">
                        <p>2023-2024</p>
                      </div>
                      <div className="info">
                        <div className="icon">
                          <img src={webluna} className='img-fluid' alt="Webluna Software" />
                        </div>
                        <div className="text">
                          <h4 className="title">Webluna Software
                          </h4>
                          <h6 className="subtitle">Front-end Developer
                          </h6>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="date">
                        <p>2023-2024</p>
                      </div>
                      <div className="info">
                        <div className="icon">
                          <img src={webcoder} alt="Webcoder Agency" />
                        </div>
                        <div className="text">
                          <h4 className="title">Webcoder Agency
                          </h4>
                          <h6 className="subtitle">Front-end Developer <br />(Intern)
                          </h6>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="date">
                        <p>2022-2023</p>
                      </div>
                      <div className="info">
                        <div className="icon">
                          <img src={matrix} alt="Matrix Academy" className='img-fluid' />
                        </div>
                        <div className="text">
                          <h4 className="title">Matrix Academy</h4>
                          <h6 className="subtitle">Front-end Developer</h6>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="date">
                        <p>2023-2024</p>
                      </div>
                      <div className="info">
                        <div className="icon">
                          <img src={adas} alt="Matrix Adas" className='img-fluid' />
                        </div>
                        <div className="text">
                          <h4 className="title">Adas</h4>
                          <h6 className="subtitle">Full-stack Developer</h6>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="date">
                        <p>2017-2021</p>
                      </div>
                      <div className="info">
                        <div className="icon ms-2">
                          <img src={wcu} alt="WCU" className='img-fluid' />
                        </div>
                        <div className="text">
                          <h4 className="title">WCU</h4>
                          <h6 className="subtitle">Polygraphy Engineer</h6>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-12">
            <div className="card expertise-card">
              <div className="card-body">
                <h3 className="card-title">{t.expert}
                </h3>
                <div className="expertise-main mt-24">
                  <div className="row g-3">
                    <div className="col-xl-4 col-md-4 col-sm-6 col-6">
                      <div className="expertise-item">
                        <div className="image text-center">
                          <img src={js} className='img-fluid' alt="JavaScript" />
                        </div>
                        <div className="text">
                          <h4 className="title">JavaScript</h4>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-4 col-md-4 col-sm-6 col-6">
                      <div className="expertise-item">
                        <div className="image text-center">
                          <img src={html} alt="HTML" />
                        </div>
                        <div className="text">
                          <h4 className="title">HTML</h4>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-4 col-md-4 col-sm-6 col-6">
                      <div className="expertise-item">
                        <div className="image text-center">
                          <img src={css} alt="CSS" />
                        </div>
                        <div className="text">
                          <h4 className="title">CSS</h4>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-4 col-md-4 col-sm-6 col-6">
                      <div className="expertise-item">
                        <div className="image text-center">
                          <img src={react} alt="React" />
                        </div>
                        <div className="text">
                          <h4 className="title">React</h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-xl-4">
        <div className="card card-projects">
          <div className="card-body">
            <h3 className="card-title">{t.recent} <Link to="/portfolio" className="link-btn" >{t.allrecent}
                <svg className="icon" width={20} height={20} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M4.16699 10H15.8337" stroke="#4770FF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M10.833 15L15.833 10" stroke="#4770FF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M10.833 5L15.833 10" stroke="#4770FF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </Link></h3>
            <div className="projects-main mt-24">
              <div className="row g-4 parent-container">
                <div className="col-lg-12">
                  <div className="project-item">
                    <div className="image">
                      <img src={data[0].img} alt="project-1" className="img-fluid w-100" />
                      <a href={data[0].img} className="gallery-popup full-image-preview parent-container">
                        <svg className="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5">
                          <path d="M10 4.167v11.666M4.167 10h11.666" />
                        </svg>
                      </a>
                    </div>
                  </div>
                </div>
                <div className="col-lg-12">
                  <div className="project-item">
                    <div className="image">
                      <img src={data[1].img} alt="project-2" className="img-fluid w-100" />
                      <a href={data[1].img} className="gallery-popup full-image-preview parent-container">
                        <svg className="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5">
                          <path d="M10 4.167v11.666M4.167 10h11.666" />
                        </svg>
                      </a>
                      {/* <div className="info">
                        <span className="category text-danger" style={{fontWeight:"bold"}}>{t.ongoing}</span>
                      </div> */}
                    </div>
                  </div>
                </div>
                <div className="col-lg-12">
                  <div className="project-item">
                    <div className="image">
                      <img src={data[2].img} alt="project-2" className="img-fluid w-100" />
                      <a href={data[2].img} className="gallery-popup full-image-preview parent-container">
                        <svg className="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5">
                          <path d="M10 4.167v11.666M4.167 10h11.666" />
                        </svg>
                      </a>
                      {/* <div className="info">
                        <span className="category text-danger" style={{fontWeight:"bold"}}>{t.ongoing}</span>
                      </div> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="services-area mt-24">
      <div className="row g-4">
        <div className="col-xl-8">
          <div className="card services-card">
            <div className="card-body">
              <h3 className="card-title">{t.service}
                {/* <a className="link-btn" href="services.html"> See All Services
                  <svg className="icon" width={20} height={20} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4.16699 10H15.8337" stroke="#4770FF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M10.833 15L15.833 10" stroke="#4770FF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M10.833 5L15.833 10" stroke="#4770FF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </a> */}
                </h3>
              <div className="services-main mt-24">
                <div className="row g-4">
                  <div className="col-md-3 col-sm-6 col-6">
                    <div className="services-item text-center">
                      <div className="image">
                        <img src="assets/img/icons/app.svg" alt="app" />
                      </div>
                      <div className="text">
                        <h3 className="title">{t.service1}</h3>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-3 col-sm-6 col-6">
                    <div className="services-item text-center">
                      <div className="image">
                        <img src="assets/img/icons/branding.svg" alt="branding" />
                      </div>
                      <div className="text">
                        <h3 className="title">{t.service2}</h3>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-4">
          <div className="card lets-talk-together-card">
            <div className="card-body">
              <div className="scrolling-info">
                <div className="slider-item">
                  <p>
                    {t.fullstack} 🚀 PHP 🎨  MYSQL
                  </p>
                </div>
              </div>
              <h6 className="card-title">{t.announcement} 👋!</h6>
              {/* <h3 className="card-title">Let's👋
                <span className="d-block">Work Together</span>
              </h3> */}
              <NavLink to="/contact" onClick={()=>window.scrollTo({top:0})} className="link-btn" > {t.talk}
                <svg className="icon" width={20} height={20} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M17.5 11.6665V6.6665H12.5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M17.5 6.6665L10 14.1665L2.5 6.6665" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </NavLink>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

    </>
  )
}

export default Home
